<template>
  <div class="search">
    <Modal
        v-model="isShow"
        :title="titleName"
        width="1050">
            <Form ref="form" :model="form" :rules="ruleValidate" label-position="top">
              <Row :gutter="32">
                  <Col span="12">
                    <FormItem label="机构名称" >
                        <Input v-model="form.orgName" clearable/>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="负责人姓名">
                        <Input v-model="form.leaderName" clearable/>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="负责人电话" >
                        <Input v-model="form.leaderPhone" clearable/>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="机构备注描述">
                        <Input v-model="form.description" clearable/>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="管理员账号" >
                        <Input v-model="form.adminAccount" clearable/>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="所在省份">
                        <Input v-model="form.provinceName" clearable/>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="城市" >
                        <Input v-model="form.cityName" clearable/>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="区、县">
                        <Input v-model="form.countyName" clearable/>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="镇" >
                        <Input v-model="form.countyName" clearable/>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="街道地址" >
                        <Input v-model="form.address" clearable/>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="设备名">
                        <Input v-model="form.deviceName" clearable/>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="设备型号">
                        <Input v-model="form.deviceModel" clearable/>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="设备联系人" >
                        <Input v-model="form.contactName" clearable/>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="设备联系电话">
                        <Input v-model="form.contactPhone" clearable/>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="设备联系人邮件">
                        <Input v-model="form.email" clearable/>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="设备安装日期">
                        <Input v-model="form.installTime" clearable/>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="保修截止日期">
                        <Input v-model="form.qcTime" clearable/>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="寿命截止日期">
                        <Input v-model="form.lifeTime" clearable/>
                    </FormItem>
                  </Col>
              </Row>
            </Form>
            <div slot="footer">
              <Button type="text" @click="modalCancel">取消</Button>
              <Button type="primary" @click="handleSubmit">确定</Button>
            </div>
    </Modal>
    <Card>
    <Row style="display: flex;justify-content: end">
        <Form ref="searchForm" inline :label-width="0" @keydown.enter.native.prevent="handleSearch">
            <FormItem>
                <Input type="text" v-model="searchForm.keyWord" placeholder="请输入关键字" clearable style="width: 200px"/>
            </FormItem>
            <FormItem class="br">
                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                <Button @click="handleReset">重置</Button>
                <!-- <Button @click="add" type="primary" icon="md-add">添加</Button> -->
                <Button 
                  @click="submit"
                  :disabled="this.selectList.length > 0 ? false : true" 
                  type="primary">批量提交</Button>
                <Button 
                  @click="remove"
                  :disabled="this.selectList.length > 0 ? false : true" 
                  type="primary">批量删除</Button>
            </FormItem>
            <!-- <FormItem style="margin-left:-80px;">
                <Button @click="exportFile">导出</Button>
            </FormItem> -->
            <FormItem>
                <Upload 
                    action="/"
                    accept=".xlsx,.xls"	
                    :headers="accessToken"
                    :before-upload="beforeUpload"	
                    :show-upload-list="false">
                <Button>导入</Button>
                </Upload>
            </FormItem>
            <FormItem>
                <button class="ivu-btn">
                  <a href="/template/piliangdaorujigoushebei.xlsx">下载模板</a>
                </button>
            </FormItem>
        </Form>
    </Row>
    <Table
    :loading="loading"
    :columns="columns"
    :data="data"
    ref="table"
    sortable="custom"
    @on-sort-change="changeSort"
    @on-selection-change="changeSelect"
    ></Table>
    <Row type="flex" justify="end" class="page">
    <Page
        :current="searchForm.pageNumber"
        :total="total"
        :page-size="searchForm.pageSize"
        @on-change="changePage"
        @on-page-size-change="changePageSize"
        :page-size-opts="[10,20,50,500]"
        size="small"
        show-total
        show-elevator
        show-sizer
    ></Page>
    </Row>
    </Card>
  </div>
</template>

<script>
import { 
  importData, 
  getOrgDeviceInfoByKeyWord, 
  insertOrUpdate, 
  delByIds,
  auditSubmit } from "./api.js"
// import dict from "@/views/my-components/jmbase/dict";

let dict  = window.jinmabasecomponents.components.dict;

function add0(m){return m<10?'0'+m:m }
function timestampToTime(timestamp) {
    var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear();
    var M = date.getMonth() + 1;
    //此处对excel导入数据特殊处理加一
    var D = date.getDate() + 1;
    return Y+'-'+add0(M)+'-'+add0(D);
};
export default {
  name: "apply",
  components: {
    dict
  },
  props: {
    deviceName: {
      String
    }
  },
  data() {
    return {
      form: { // 添加或编辑表单对象初始化数据
        orgName: "",
        leaderName: "",
        leaderPhone: "",
        description: "",
        preContent: "",
        adminAccount: "",
        provinceName: '',
        cityName: '',
        countyName: '',
        address:'',
        deviceName: '',
        contactName: '',
        contactPhone: '',
        email: '',
        installTime: '',
        qcTime: '',
        lifeTime: '',
      },
      titleName: '',
      isShow: false,
      openSearch: true, // 显示搜索
      openTip: true, // 显示提示
      formData: {},
      currView: "index",
      loading: false, // 表单加载状态
      searchForm: { // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        sort: "id", // 默认排序字段
        order: "desc", // 默认排序方式
        keyWord: '',
        onlyMy: 'yes',
        status: ''
      },
      dataList: null,
      selectList: [], // 多选数据
      ruleValidate: {
        name: [
            { required: true, message: '请输入数据源名称', trigger: 'change' }
        ],
        type: [
            { required: true, message: '请选择数据源类型', trigger: 'change' }
        ],
        content: [
            { required: true, message: '请输入数据源', trigger: 'change' }
        ]
      },
      columns: [
      {
        type: 'selection',
        width: 60,
        align: 'center'
      },
      {
        title: "机构名称",
        key: "orgName",
        minWidth: 120,
        sortable: false,
      },
      {
        title: "负责人姓名",
        key: "leaderName",
        minWidth: 120,
        sortable: false,
      },
      {
        title: "负责人电话",
        key: "leaderPhone",
        minWidth: 120,
        sortable: false,
      },
      {
        title: "机构备注描述",
        key: "description",
        minWidth: 120,
        sortable: false,
      },
      {
        title: "管理员账号",
        key: "adminAccount",
        minWidth: 120,
        sortable: false,
      },
      {
        title: "所在省份",
        key: "provinceName",
        minWidth: 120,
        sortable: false,
      },
      // {
      //   title: "城市",
      //   key: "cityName",
      //   minWidth: 120,
      //   sortable: false,
      // },
      // {
      //   title: "区、县",
      //   key: "countyName",
      //   minWidth: 120,
      //   sortable: false,
      // },
      // {
      //   title: "镇",
      //   key: "townName",
      //   minWidth: 120,
      //   sortable: false,
      // },
      // {
      //   title: "街道地址",
      //   key: "address",
      //   minWidth: 120,
      //   sortable: false,
      // },
      {
        title: "设备名",
        key: "deviceName",
        minWidth: 120,
        sortable: false,
      },
      {
        title: "设备型号",
        key: "deviceModel",
        minWidth: 120,
        sortable: false,
      },
      {
        title: "设备联系人",
        key: "contactName",
        minWidth: 120,
        sortable: false,
      },
      {
        title: "设备联系电话",
        key: "contactPhone",
        minWidth: 120,
        sortable: false,
      },
      {
        title: "审核状态",
        key: "docStatusTitle",
        minWidth: 120,
        sortable: false,
        filters: [{
          label: '草稿',
          value: 100
        },{
          label: '待审',
          value: 200
        },{
          label: '已通过',
          value: 300
        },{
          label: '已驳回',
          value: 400
        }],
        filterMultiple: false,
        filterRemote: (e) => {
            let v = "";
            if (e.length > 0) {
                v = e[0];
            }
            this.searchForm.status = v;
            this.searchForm.pageNumber = 1;
            this.getDataList();
        },
      },
      // {
      //   title: "设备联系人邮件",
      //   key: "email",
      //   minWidth: 120,
      //   sortable: false,
      // },
      {
        title: "操作",
        key: "action",
        align: "center",
        width: 200,
        render: (h, params) => {
          let editKongjian = "";
            editKongjian = h(
            "a",
            {
              on: {
                click: () => {
                  this.edit(params.row);
                }
              }
            },
            "编辑"
          );
              
          let delKongjian = "";
            delKongjian = h(
            "a",
            {
              on: {
                click: () => {
                  this.remove(params.row);
                }
              },
              style: {
                color: '#FF0000'
              }
            },
            "删除"
          );

          let submit = "";
            submit = h(
            "a",
            {
              on: {
                click: () => {
                  this.submit(params.row);
                }
              }
            },
            "提交"
          );
          if(params.row.docStatus == 100 || params.row.docStatus == 400) {
            return h("div", [ 
              editKongjian, 
              h("Divider", {
                props: {
                  type: "vertical",
                },
              }),      
              submit,
              h("Divider", {
                props: {
                  type: "vertical",
                },
              }),   
              delKongjian           
            ]);
          }else {
            return h("div");
          }
        }
      }
    ],
      data: [], // 表单数据
      pageNumber: 1, // 当前页数
      pageSize: 10, // 页面大小
      total: 0 // 表单数据总数
    };
  },
  beforeCreate() {
        // 读取文件
        FileReader.prototype.reading = function ({encode} = pms) {
          let bytes = new Uint8Array(this.result);    //无符号整型数组
          let text = new TextDecoder(encode || 'UTF-8').decode(bytes);
          return text;
        };
        /* 重写readAsBinaryString函数 */
        FileReader.prototype.readAsBinaryString = function (f) {
          if (!this.onload)       //如果this未重写onload函数，则创建一个公共处理方式
            this.onload = e => {  //在this.onload函数中，完成公共处理
              let rs = this.reading();
            };
          this.readAsArrayBuffer(f);  //内部会回调this.onload方法
        };
  },
  created() {
    this.accessToken = {
      accessToken: this.getStore("accessToken"),
    };
  },
  methods: {
    addItem() {
      const v = ''
      this.listItems.push(v)
    },
    addEnum() {
      const v = ''
      this.enums.push(v)
    },
    delEnum(e) {
      this.enums.splice(e,1)
    },
    delItem(e) {
      this.listItems.splice(e,1)
    },
    submit(v) {
      let data = "";
      if(v.id) {
        data = v.id
      }else{
        data = this.selectList
      }
      auditSubmit({ids: data}).then((res) => {
          if (res.success) {
            this.$Message.success('提交成功！')
            this.getDataList();
          }else{
            this.$Message.success('提交失败！')
            return false;
          }
      });
    },
    beforeUpload(file){
        this.fileTemp = file
        if(this.fileTemp){
            if((this.fileTemp.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') || (this.fileTemp.type == 'application/vnd.ms-excel')){
                this.import(this.fileTemp)
            } else {
                this.$message({
                    type:'warning',
                    message:'附件格式错误，请删除后重新上传！'
                })
            }
        } else {
            this.$message({
                type:'warning',
                message:'请上传附件！'
            })
        }
        // 读取数据
        return false
    },
    import(obj) {
        let _this = this;
        // 通过DOM取文件数据
        this.file = obj
        var rABS = false; //是否将文件读取为二进制字符串
        var f = this.file;
        var reader = new FileReader();
        function formatData(v) {
          if(v instanceof Date){
            return timestampToTime(v.getTime())
          }else{
            return v
          }
        }
        //if (!FileReader.prototype.readAsBinaryString) {
        FileReader.prototype.readAsBinaryString = (f)=> {
            var binary = "";
            var rABS = false; //是否将文件读取为二进制字符串
            var pt = this;
            var wb; //读取完成的数据
            var outdata;
            var reader = new FileReader();
            reader.onload = function(e) {
            var bytes = new Uint8Array(reader.result);
            var length = bytes.byteLength;
            for(var i = 0; i < length; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            var XLSX = require('xlsx');
            if(rABS) {
                wb = XLSX.read(btoa(fixdata(binary)), { //手动转化
                    type: 'base64',
                    cellDates: true
                });
            } else {
                wb = XLSX.read(binary, {
                    type: 'binary',
                    cellDates: true
                });
            }
            outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);//outdata就是你想要的东西
            this.da = [...outdata]
            let arr = []
            this.da.map(v => {
                let obj = {}
                obj.orgName = v['机构名称*']
                obj.leaderName = v['负责人姓名']
                obj.leaderPhone = v['负责人电话']
                obj.description = v['机构备注描述']
                obj.adminAccount = v['管理员账号*']
                obj.provinceName = v['所在省份']
                obj.cityName = v['城市']
                obj.countyName = v['区、县']
                obj.townName = v['镇']
                obj.address = v['街道地址']
                obj.deviceName = v['设备名*']
                obj.deviceModel = v['设备型号']
                obj.contactName = v['设备联系人']
                obj.contactPhone = v['设备联系电话']
                obj.email = v['设备联系人邮件']
                obj.installTime = formatData(v['安装日期'])
                obj.qcTime = formatData(v['保修截止日期'])
                obj.lifeTime = formatData(v['寿命截止日期'])
                arr.push(obj)
            })
            var dataInfo = {
                fileContent: ''
            }
            dataInfo.fileContent = arr;
            console.log(arr)
            importData(dataInfo).then(res => {
                if (res.success) {
                    _this.$Message.success("导入成功")
                    _this.submited();
                }else{
                    _this.$Message.error("导入失败")
                }
            });
            return arr
            }
            reader.readAsArrayBuffer(f);
        }
        
        if(rABS) {
            reader.readAsArrayBuffer(f);
        } else {
            reader.readAsBinaryString(f);
        }
    },
    init() {
      this.getDataList();
    },
    submited() {
      this.currView = "index";
      this.getDataList();
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataList();
    },
    handleReset() {
      this.searchForm.keyWord = '';
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      // 重新加载数据
      this.getDataList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(data) {
      let arr = [];
      data.forEach(item =>{
        arr.push(item.id);
      })
      this.selectList = arr.toString();
    },
    getDataList() {
      this.loading = true;
        getOrgDeviceInfoByKeyWord(this.searchForm).then(res => {
          this.loading = false;
          if (res.success) {
            this.data = res.result.records;
            this.data.forEach(item=> {
              if(item.docStatus != 100 && item.docStatus != 400){
                item._disabled = true
              }
            })
            this.total = res.result.total;
            if (this.data.length == 0 && this.searchForm.pageNumber > 1) {
              this.searchForm.pageNumber -= 1;
              this.getDataList();
            }
          }
        });
    },
    add() {
      this.$refs.form.resetFields();
      this.titleName = '添加';
      this.isShow =true;
      const form = {
        name: "",
        unit: "",
        enums: [""],
        preContent: "",
        content: "",
        deviceId: '',
        type: '布尔',
        isFaultDataSource: 'no',
        isAlwaysRun:'no',
        eventLevel: '0',
        faultValue: '',
        faultPart: '',
        faultLocation: '',
        isWarningDataSource: 'no',
        warningCode: '',
        warningMsg: ''
      }
      this.form = form;
      //v-for无法解析多层嵌套
      this.enums = this.form.enums;
      this.currView = "add";
    },
    edit(v) {
      this.titleName = '编辑';
      this.isShow = true;
      // 转换null为""
      for (let attr in v) {
        if (v[attr] == null) {
          v[attr] = "";
        }
      }
      let str = JSON.stringify(v);
      let data = JSON.parse(str);
      this.formData = data;
      this.form = this.formData;
      if(this.form.enums == []){
        this.enums = [''];
      }else{
        //v-for无法解析多层嵌套
        this.enums = this.form.enums;
      }
      if(this.form.listItems == []){
        this.listItems = [''];
      }else{
        //v-for无法解析多层嵌套
        this.listItems = this.form.listItems;
      }
      this.currView = "edit";
    },
    getQueryString(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    },
    modalCancel() {
      this.isShow = false
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if(this.currView == 'edit'){
            insertOrUpdate(this.form).then(res => {
              this.isShow = false
              if (res.success) {
                this.$Message.success("操作成功");
                this.submited();
              }
            });
          }else{
            insertOrUpdate(this.form).then(res => {
              this.isShow = false
              if (res.success) {
                this.$Message.success("操作成功");
                this.submited();
              }
            });
          }
        }
      });
    },
    remove(v) {
      let data = "";
      if(v.id) {
        data = v.id
      }else{
        data = this.selectList
      }
      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除选中数据?",
        loading: true,
        onOk: () => {
          // 删除
            delByIds({ids: data}).then(res => {
              this.$Modal.remove();
              if (res.success) {
                this.$Message.success("操作成功");
                this.clearSelectAll();
                this.getDataList();
              }else if(res.code == 501){
                this.$Message.error({
                    content: res.message,
                    duration: 10,
                    closable: true
                });
              }
            });
        }
      });
    },
    //导出数据源
    formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
    },
    exportFile() {
      this.searchForm.pageSize = 100000;
      getDataSourceByKeyWord(this.searchForm).then((res) => {
          if (res.success) {
            this.dataList = res.result.records;
            require.ensure([], () => {
                const { export_json_to_excel } = require('./vender/Export2Excel.js')
                const tHeader = [
                  '机构名称', 
                  '负责人姓名', 
                  '负责人电话', 
                  '机构备注描述',
                  '管理员账号', 
                  '所在省份', 
                  '区、县', 
                  '镇', 
                  '街道地址', 
                  '设备名',
                  '设备联系人',
                  '设备联系电话',
                  '设备联系人邮件',
                  '设备安装日期',
                  '设备保修期',
                  '设备寿命截至日期',
                ];
                const filterVal = [
                  'orgName', 
                  'leaderName', 
                  'leaderPhone', 
                  'description', 
                  'adminAccount', 
                  'cityName', 
                  'countyName', 
                  'townName', 
                  'address',
                  'deviceName',
                  'contactName',
                  'contactPhone',
                  'email',
                  'installTime',
                  'qcTime',
                  'lifeTime',
                ]
                const list = this.dataList
                const data = this.formatJson(filterVal, list)
                export_json_to_excel(tHeader, data, this.deviceName + '_数据源')
            })
          }
      });
    },
    delAll() {
      if (this.selectList.length <= 0) {
        this.$Message.warning("您还未选择要删除的数据");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除所选的 " + this.selectList.length + " 条数据?",
        loading: true,
        onOk: () => {
          let ids = "";
          this.selectList.forEach(function(e) {
            ids += e.id + ",";
          });
          ids = ids.substring(0, ids.length - 1);
          // 批量删除
            deleteMonitorConfig({ids: ids}).then(res => {
              this.$Modal.remove();
              if (res.success) {
                this.$Message.success("操作成功");
                this.clearSelectAll();
                this.getDataList();
              }
            });
        }
      });
    }
  },
  computed: {
    
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
// 建议引入通用样式 具体路径自行修改 可删除下面样式代码
// @import "@/styles/table-common.less";
.search {
    .operation {
        margin-bottom: 2vh;
    }
    .select-count {
        font-weight: 600;
        color: #40a9ff;
    }
    .select-clear {
        margin-left: 10px;
    }
    .page {
        margin-top: 2vh;
    }
    .drop-down {
        margin-left: 5px;
    }
    .name {
        display: flex;
        margin-bottom: 25px;
        align-items: center;
        .content {
            margin-left: 10px;
            font-size: 20px;
            font-weight: bold;
        }
        .bar {
            width: 6px;
            height: 29px;
            background-color: #307AEA;
            border-radius: 5px;
        }
    }
    .form {
        position: absolute;
        right: 20px;
    }
}
</style>